import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, CDN_URL, formatDate, formatMoney, formatMoneyShorten, remove255 } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import SubscriptionExpiredWidget from '../ones/SubscriptionExpiredWidget';
import { RxHeart, RxHeartFilled } from "react-icons/rx";
import { FaRegCommentDots } from "react-icons/fa6";
import { STR_ALREADY_CANCELLED, STR_ALREADY_PAID, STR_BUY_NOW, STR_CANCEL_ORDER, STR_CART_WAS_UPDATED, STR_CLICK_TO_VIEW_COMMENTS, STR_CONTACT_US, STR_ENTER_PAYPHONE, STR_ENTER_PHONE_NUMBER_FOR_PAYMENT, STR_GO_BACK, STR_IS_CANCELLED, STR_IS_DELIVERED, STR_IS_PAID, STR_IS_SHIPPED, STR_MAKE_PAYMENT, STR_NO, STR_ORDERED_ITEMS, STR_OVERALL_COST, STR_PAY_NOW, STR_PAY_WITH_CARD, STR_PAY_WITH_MOBILE, STR_PHARMACY_ORDER_FINAL_TEXT_CARD, STR_PHARMACY_ORDER_FINAL_TEXT_PHONE, STR_SELECT_PAYMENT_METHOD, STR_SHIPPING_COST, STR_TRANSACTION_FEES, STR_WRITE_YOUR_COMMENT, STR_YES } from "../Strings";
import LoginView from '../views/LoginView';
import ImagesSlider from "../ones/ImagesSlider";
import { MdAdd, MdCheckCircle, MdClose } from "react-icons/md";
import { BiMinus, BiSolidCartDownload } from "react-icons/bi";
import MobileInterface from "../MobileInterface";


export default function View({ id }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [data, setData] = useState(null);
	const [opSuccessful, setOpSuccessful] = useState(false);
	const [loading, setLoading] = useState(false);

	const [payWith, setPayWith] = useState('mobile_money');
	const [payPhone, setPayPhone] = useState(remove255(appContext.currentUserData.phone));

	async function init() {
		//run initializations here
		setReady(false);
		await getData();
		setReady(true);
	}

	async function pay() {
		
		if(
			(payPhone && payPhone.trim().length === 10 && payWith === 'mobile_money') ||
			payWith === 'credit_card' 
		) {

			setLoading(true);
			await callApi(
				'trigger-pharmacy-order-payment',
				{
					orderId: data.id,
					payPhone,
					payWith,
				}
			).then(response => {
				if(response.status === 1) {
					setOpSuccessful(true);
					if (payWith === 'credit_card') {
						MobileInterface.openLink(response.payment_gateway_url);
					}

				} else {
					appContext.tellError(response.msg);
				}
			})
			setLoading(false);
		} else {
			appContext.tellError(STR_ENTER_PHONE_NUMBER_FOR_PAYMENT[appContext.language]);
		}
			
	}
	

	async function getData() {
		await callApi("get-pharmacy-order-data", { id }).then(response => {
			if (response.status === 1) {
				setData(response.data);
			}
		})
	}


	useEffect(() => {
		init();
	}, [])


	useEffect(() => {
		//..
	}, [ data ]);

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])
	
	if (ready && data) {
		return (
			<div className="container">
				<div className="row">
					<div className="col-md-12">
						<div
							className="mt-4 mb-4"
						>
							<h6
								style={{
									fontSize: "22px"
								}}
								className="font-bold text-secondary"
							>
								TZS {formatMoney(data.overallCost)}
							</h6>

							<h6
								className="font-bold text-muted"
								style={{
									fontSize: "12px",
									marginTop: "20px",
									marginBottom: "20px"
								}}
							>
								{
									(JSON.parse(data.items)).map((item, i) => {
										return (
											<span
												key={i}
											>
												{item.title},
											</span>
										)
									})
								}
							</h6>

							<h6
								style={{
									fontSize: "12px"
								}}
								className="font-bold text-muted mt-2 mb-2"
							>
								ID: <span className="text-secondary font-bold">{data.uid}</span>
							</h6>
				
							<h6
								style={{
									fontSize: "12px"
								}}
								className="font-regular mt-4 text-end"
							>
								{formatDate(data.dateCreated)}
							</h6>
				
				
						</div>
						
						<div className="card">
							<div className="card-body">
								
								{
									(data.isPaid === 'no') ?
									(data.isCancelled === 'no') ?
									<>
										<h6 className="card-title">{STR_MAKE_PAYMENT[appContext.language]}</h6>
										<hr/>

										{
											(opSuccessful) ?
											<div className="row">
												<div className="col-md-12 mt-4 mb-4">
													<h6
														style={{
															fontSize:"18px"
														}}
														className="font-semi-bold text-center mt-4 mb-4"
													>
														<MdCheckCircle size={72} className="text-secondary"/>
														<br/>
														{
															(payWith === 'mobile_money') ?
															STR_PHARMACY_ORDER_FINAL_TEXT_PHONE[appContext.language]
															:""
														}
					
														{
															(payWith === 'credit_card') ?
															STR_PHARMACY_ORDER_FINAL_TEXT_CARD[appContext.language]
															:""
														}
													</h6>
					
													<div className="text-center">
														<button
															className="btn btn-padded btn-rounded btn-primary"
															onClick={appContext.navBack}
														>
															{STR_GO_BACK[appContext.language]}
														</button>
													</div>
												</div>
											</div>
											:
											<div className="row">
							
												
												<div className="col-md-12">
													
													<div className="mt-4 mb-4">
														<label className="form-label">{STR_SELECT_PAYMENT_METHOD[appContext.language]}</label>
														<select
															className="form-control"
															value={payWith}
															onChange={(e) => setPayWith(e.target.value)}
														>
															<option value="mobile_money">{STR_PAY_WITH_MOBILE[appContext.language]}</option>
															<option value="credit_card">{STR_PAY_WITH_CARD[appContext.language]}</option>
														</select>
													</div>
					
													<div className="mt-4 mb-4" style={{ display: (payWith === 'mobile_money') ? 'block' : 'none' }}>
														<label className="form-label">{STR_ENTER_PAYPHONE[appContext.language]}</label>
														<input
															className="form-control"
															value={payPhone}
															onChange={(e) => setPayPhone(e.target.value)}
															maxLength={10}
															minLength={10}
														/>
														<div className="form-text">07XXXXXXXX or 06XXXXXXXX</div>
														
													</div>
														
												</div>
					
												<div className="col-md-12 mb-4 mt-2">
													<button
														className="btn btn-block btn-rounded btn-padded btn-primary mb-4"
														onClick={pay}
													>
														{STR_PAY_NOW[appContext.language]}
													</button>
												</div>
					
											</div>
											
											
										}
										

									</>
									:
									<h6 className="text-center" style={{ fontSize: "24px" }}>
										<MdClose className="text-danger" size={72}/>
										<br/>
										{STR_ALREADY_CANCELLED[appContext.language]}
									</h6>
									:
									<h6 className="text-center" style={{ fontSize: "24px" }}>
										<MdCheckCircle className="text-secondary" size={72}/>
										<br/>
										{STR_ALREADY_PAID[appContext.language]}
									</h6>
								}
								
							</div>
						</div>
					</div>

					

				</div>
			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading container"
			>
				{getInlineLoader()}
			</div>
		);
	}
	

}